import React, { useState } from 'react'
import PropTypes from 'prop-types'
import FormAndCalloutBox from '../../../3_Organisms/FormAndCalloutBox/FormAndCalloutBox'
import parse from 'html-react-parser';
import Input from '../../../1_Atoms/Forms/Input/Input';
import Button from '../../../1_Atoms/Button/Button';
import FormGroup from '../../../2_Molecules/FormGroup/FormGroup';
import { handleRequest } from '../../../../utils/httpRequest';
import Form from '../../../2_Molecules/Form/Form';
import { languageController } from '../../../../controllers/language/languageController';
import { useForm } from '../../../../hooks/useForm';
import Textarea from '../../../1_Atoms/Forms/Textarea/Textarea';
import Checkbox from '../../../1_Atoms/Forms/Checkbox/Checkbox';
import { autoFormatPhoneNumber, convertLangCodeToSingleLetter, formatDate } from '../../../../utils/helpers';
import CalloutBoxFull from '../../../2_Molecules/CalloutBox/CalloutBoxFull';
import pidController from '../../../../controllers/pidController';
import { getEndpointUrl } from '../../../../utils/endPoints';

function ContactDetailsStep_BaSA({
  handleNextStep,
  dealerData,
  dateAndTimeData,
  vehicleData,
  serviceDetails,
  formLanguage,
}) {
  const [formError, setFormError] = useState(null)

  const { dealer: selectedDealerData, userPosition } = dealerData || {};

  const initState = {
    firstname: '',
    lastname: '',
    email: '',
    postalcode: '',
    message: '',
    optin: 'off', // 'on' or 'off'
    phone: ''
  }

  const validations = {
    firstname: ['required', 'name', 'nameMaxMin'],
    lastname: ['required', 'name', 'nameMaxMin'],
    email: ['required', 'email'],
    postalcode: ['required', 'postalcode'],
    phone: ['phone']
  }

  const { handleSubmit, handleChange, data: formData, errors, setData } = useForm({
    initState,
    validations,
    // Send the form data if validated
    onSubmit: async () => {
      try {
        const otherData = {
          language: convertLangCodeToSingleLetter(formLanguage),
          pid: String(pidController.getPid('serviceAppt'))
        }

        // Add selectedDealerData data
        if (selectedDealerData) {
          otherData.dealerid = selectedDealerData.dealer_code
        }

        // Add vehicleData data
        if (vehicleData) {
          otherData.odometer = vehicleData.kilometers;
          otherData.vehiclemodel = vehicleData.model;
          otherData.vehicleyear = vehicleData.modelYear;
          otherData.vinnumber = vehicleData.vin;
        }

        // Add serviceDetails data
        if (serviceDetails) {
          otherData.servicerequired = serviceDetails.services;
          otherData.additionalinformation = serviceDetails.message;
        }

        // Add Date and Time data
        if (dateAndTimeData) {
          otherData.date = formatDate(dateAndTimeData.date)
          otherData.time = dateAndTimeData.time
        }

        const res = await handleRequest('post', getEndpointUrl('service-appt'), { ...formData, ...otherData });

        if (res.Success) {
          handleNextStep({ contactDetails: formData })
        } else {
          setFormError(res.state ? res.state : res.Errors[0])
        }
      } catch (err) {
        console.log(err)
      }
    },
  })

  const { firstname, lastname, email, postalcode, message, optin, phone } = formData;

  const isFormFilled = (firstname && lastname && email && postalcode)

  return (
    <div className="mz-contact-details-step">
      <div className="mz-contact-details-step__top">
        <div className="mz-container">
          <div className="mz-full-width">
            <h5 className="mz-contact-details-step__title">{languageController.getCopy('global', 'fillContactForm')}</h5>
          </div>
        </div>
      </div>
      <FormAndCalloutBox>
        <FormAndCalloutBox.Form>
          <Form
            type="contact-details"
            onSubmit={handleSubmit}
            isDark={false}
            noValidate={true}
            requiredFieldsHelperText={true}
            errorMessage={formError}
          >
            <FormGroup md={2}>
              <Input
                type="text"
                name="firstname"
                label={languageController.getFormCopy('label', 'firstname')}
                value={firstname}
                isRequired={true}
                errorMessage={errors.firstname}
                onChange={handleChange}
                maxLength={50}
              />
              <Input
                type="text"
                name="lastname"
                label={languageController.getFormCopy('label', 'lastname')}
                value={lastname}
                isRequired={true}
                errorMessage={errors.lastname}
                onChange={handleChange}
                maxLength={50}
              />
            </FormGroup>
            <Input
              type="email"
              name="email"
              label={languageController.getFormCopy('label', 'email')}
              value={email}
              isRequired={true}
              errorMessage={errors.email}
              onChange={handleChange}
              maxLength={320}
            />
            <FormGroup md={2}>
              <Input
                type="text"
                name="postalcode"
                label={languageController.getFormCopy('label', 'postalcode')}
                value={postalcode}
                isRequired={true}
                errorMessage={errors.postalcode}
                onChange={handleChange}
                maxLength={7}
              />
              <Input
                type="tel"
                name="phone"
                label={languageController.getFormCopy('label', 'phone')}
                value={phone}
                errorMessage={errors.phone}
                onChange={(e) => {
                  setData({ ...formData, phone: autoFormatPhoneNumber(e.target.value) });
                }}
                maxLength={17}
              />
            </FormGroup>
            <Textarea
              name="message"
              label={languageController.getFormCopy('label', 'message2500')}
              value={message}
              errorMessage={errors.message}
              onChange={handleChange}
              maxLength={2500}
              rows={5}
            />
            <Checkbox
              name="optin"
              checked={(optin === 'on')}
              onChange={(e) => setData({ ...formData, optin: optin === 'off' ? 'on' : 'off' })}
              label={parse(languageController.getCopy('global', 'subscribeLegal'))}
            />
            <Button
              type="submit"
              className="mz-btn--primary mz-btn--red"
              label={languageController.getCopy('bookServiceAppointment', 'step5Submit')}
              disabled={!isFormFilled}
            />
          </Form>
        </FormAndCalloutBox.Form>
        <FormAndCalloutBox.Callout>
          <CalloutBoxFull
            vehicleData={vehicleData}
            dealerData={selectedDealerData}
            userPosition={userPosition}
            dateAndTimeData={dateAndTimeData}
            isOwnVehicleType={true}
          />
        </FormAndCalloutBox.Callout>
      </FormAndCalloutBox>
    </div>
  )
}

ContactDetailsStep_BaSA.propTypes = {
  handleNextStep: PropTypes.func.isRequired,
  formLanguage: PropTypes.string.isRequired,
  dealerData: PropTypes.object,
  dateAndTimeData: PropTypes.object,
  vehicleData: PropTypes.object,
  serviceDetails: PropTypes.object,
}

ContactDetailsStep_BaSA.defaultProps = {
  formLanguage: 'en',
  dealerData: null,
  dateAndTimeData: null,
  vehicleData: null,
  serviceDetails: null,
}

export default ContactDetailsStep_BaSA